import { FolderOpen } from 'lucide-react'
import { useLocation } from 'react-router'
import { BreadcrumbItem, BreadcrumbPage } from '@/components/ui/breadcrumb'

export const ProjectBreadcrumb = () => {
  const { pathname } = useLocation()

  return (
    <>
      {pathname.includes('/projects') ? (
        <BreadcrumbItem>
          <BreadcrumbPage className="flex items-center gap-2 px-2">
            <FolderOpen className="size-3.5" aria-hidden="true" />
            <span className="font-medium">Projects</span>
          </BreadcrumbPage>
        </BreadcrumbItem>
      ) : null}
    </>
  )
}
